/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import FocusLock from 'react-focus-lock';
import classNames from 'classnames';
import Backdrop from './Backdrop';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import defaultTheme from '../../themes/default';
import useModal from './useModal';
import Button from '../buttons_refactor/Button';
import { ICONS } from '../../constants/icons';

const Modal = ({ hasX = true, isDismissable = true, children, className }) => {
  const [{ isOpen }, modalDispatch] = useModal();

  React.useEffect(() => {
    const handlePopAndPushState = () => {
      modalDispatch({ type: 'close' });
    };

    window.addEventListener('popstate', handlePopAndPushState);
    window.addEventListener('pushstate', handlePopAndPushState);

    // clean up event listener from previous render
    return () => {
      window.removeEventListener('popstate', handlePopAndPushState);
      window.removeEventListener('pushstate', handlePopAndPushState);
    };
  }, []);

  return isOpen ? (
    <Backdrop
      onClick={isDismissable ? () => modalDispatch({ type: 'toggle' }) : null}
    >
      <FocusLock>
        <div
          className={classNames(defaultTheme.modal.base, className)}
          onClick={e => {
            e.stopPropagation();
          }}
          onKeyUp={e => {
            if (e.key === 'Escape') {
              modalDispatch({ type: 'close' });
            }
          }}
          role="dialog"
        >
          {hasX && (
            <Button
              tag="icon"
              variant="icon"
              icon={ICONS.X}
              className="absolute top-4 right-4 opacity-50 focus:opacity-100 2xl:top-7 2xl:right-12"
              onClick={() => modalDispatch({ type: 'toggle' })}
            />
          )}
          {children}
        </div>
      </FocusLock>
    </Backdrop>
  ) : null;
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
